export const BS_EVENTS = {
	COLLAPSE: {
		SHOW: 'show.bs.collapse',
		SHOWN: 'shown.bs.collapse',
		HIDE: 'hide.bs.collapse',
		HIDDEN: 'hidden.bs.collapse',
	},
	DROPDOWN: {},
	MODAL: {
		SHOW: 'show.bs.modal',
		SHOWN: 'shown.bs.modal',
		HIDE: 'hide.bs.modal',
		HIDDEN: 'hidden.bs.modal',
	},
};
